module.exports = __webpack_public_path__ + "img/56212.prt.6e2088ed.jpg";